module.exports = __webpack_public_path__ + "static/media/ball_001_a.47494b4b.png";